module.exports = __webpack_public_path__ + "img/setting.ca913ac0.svg";